import { Group, Checkbox, Text, Box, Stack } from "@mantine/core"

import { LabelsExplorerResponses } from "@costory/types/endpoints/labelsExplorer"

import { formatNumber } from "@costory/shared/utils/format"

import { CustomCopyCellButton } from "@costory/front/components/common/CustomCopyCellButtton"
import { ProviderPills } from "@costory/front/pages/LabelsExplorer/ProviderPill"

interface LabelListItemProps {
  label: LabelsExplorerResponses.LabelsStatsFullBilling
  // Do not declare `key` in props; React reserves it and will not pass it down
  onHoverLabel: (
    label: LabelsExplorerResponses.LabelsStatsFullBilling | null,
  ) => void
  hoveredLabel: LabelsExplorerResponses.LabelsStatsFullBilling | null
  ingestMode?: boolean
  checked?: boolean
  onCheck?: (key: string, checked: boolean) => void
  disabled?: boolean
}

export function LabelListItem({
  label,
  onHoverLabel,
  hoveredLabel,
  ingestMode = false,
  checked = false,
  onCheck,
  disabled = false,
}: LabelListItemProps) {
  return (
    <Box
      p="8px 12px"
      display="flex"
      miw={0}
      style={{
        cursor: "default",
        borderRadius: "4px",
        backgroundColor:
          hoveredLabel?.key === label.key ? "surfaceHover" : "transparent",
        transition: "all 0.2s ease",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      onMouseEnter={() => {
        onHoverLabel(label)
      }}
      onMouseLeave={() => {
        onHoverLabel(null)
      }}
    >
      <Group gap="sm" flex={1} miw={0} align="flex-start">
        <Checkbox
          checked={checked || label.ingested}
          onChange={
            ingestMode
              ? (e) => onCheck && onCheck(label.key, e.currentTarget.checked)
              : undefined
          }
          disabled={!ingestMode || label.ingested || disabled}
          onClick={(e) => e.stopPropagation()}
          style={{ marginTop: "2px" }}
        />
        <Stack gap={2} flex={1} miw={0}>
          <Text
            fw={500}
            size="sm"
            flex={1}
            miw={0}
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {label.key}
          </Text>
          <Box mt={2}>
            <ProviderPills providers={label.providers} />
          </Box>
        </Stack>
      </Group>

      <Group gap="xs" align="center" style={{ flexShrink: 0 }}>
        <CustomCopyCellButton value={String(label.total_cost_key_present)}>
          <Text size="sm" c="dimmed" miw="40px" ta="right">
            {formatNumber({ value: label.total_cost_key_present })}
          </Text>
        </CustomCopyCellButton>
      </Group>
    </Box>
  )
}
